import { useMutation } from '@tanstack/react-query';
import { AuthLayout } from '../../ui/AuthLayout/AuthLayout';
import { AuthStep } from '../../ui/AuthStep/AuthStep';
import { ResetRequest } from '@/bundle/shared/components/ResetRequest/ResetRequest';
import { useState } from 'react';
import { getResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { resetRequestAuth } from './api';
import { useAuthNavigateToLogin } from '@/bundle/Auth/hooks/useAuthNavigateToLogin';

export const ResetRequestAuthPage = () => {
  const { authNavigateToLogin } = useAuthNavigateToLogin();

  const [confirmationStep, setConfirmationStep] = useState(true);

  const { mutate, data, isPending } = useMutation({
    mutationKey: ['reset_request_auth'],
    mutationFn: () => {
      return resetRequestAuth();
    },
    onSuccess(response) {
      if (response?.error) return;

      setConfirmationStep(false);
    },
  });

  const error = getResponseError(data?.error);

  return (
    <AuthLayout>
      <AuthStep>
        <ResetRequest
          confirmationStep={confirmationStep}
          isLoading={isPending}
          error={error}
          onConfirm={mutate}
          onSuccess={authNavigateToLogin}
          onCancel={authNavigateToLogin}
        />
      </AuthStep>
    </AuthLayout>
  );
};
